'use client'

import { Badge } from '@natera/platform/lib/components/badge'
import { Collapsible } from 'radix-ui'
import * as React from 'react'
import { cn } from '~/shared/lib/cn'
import { LocalIcon, Text } from '~/shared/ui'
import './collapsible.scss'

function CollapsibleRoot({ ...props }: React.ComponentProps<typeof Collapsible.Root>) {
  return (
    <Collapsible.Root
      defaultOpen
      {...props}
    />
  )
}

interface CollapsibleTriggerProps extends React.ComponentProps<typeof Collapsible.Trigger> {
  label: string
  labelClassName?: string
  counter?: number
}

function CollapsibleTrigger({
  className,
  label,
  labelClassName,
  counter,
  ...props
}: CollapsibleTriggerProps) {
  return (
    <Collapsible.Trigger
      className={cn(
        'group bg-surface-lowest text-text-primary relative flex w-full flex-1 cursor-pointer items-center justify-between gap-4 border-none p-0 text-left transition-all outline-none disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <Text
        className={cn('uppercase', labelClassName)}
        appearance="OVERLINE"
      >
        {label}
      </Text>
      <LocalIcon
        className="text-action-active p-1"
        name="expandAll"
        size="18"
      />
      {counter && (
        <Badge
          className="[&_.badge\_\_content]:bg-primary-main absolute top-0 right-0 group-data-[state=open]:[&_.badge\_\_content]:hidden"
          badgeContent={counter.toString()}
        />
      )}
    </Collapsible.Trigger>
  )
}

function CollapsibleContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof Collapsible.Content>) {
  return (
    <Collapsible.Content
      className={cn('c-collapsible__content overflow-hidden', className)}
      {...props}
    >
      {children}
    </Collapsible.Content>
  )
}

export { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger }
